export function formatStatisticValue(value: string, locale: string): string {
  if (!/^-?\d+(\.\d+)?$/.test(value)) return value;
  const [integer, fraction] = value.split('.');
  const parts = new Intl.NumberFormat(locale).formatToParts(1234.5);
  const group = parts.find((part) => part.type === 'group')?.value ?? '\u00a0';
  const decimal = parts.find((part) => part.type === 'decimal')?.value ?? '.';
  return integer.replace(/\B(?=(\d{3})+(?!\d))/g, group) + (fraction ? decimal + fraction : '');
}
